import DeviceLogsTable from './DeviceLogsTable';

const DeviceLogsSection = () => {
  return <DeviceLogsTable />;
};

export default DeviceLogsSection;
